export const mutations = {
  STORE_PETTYACCOUNTS(state, pettyaccounts) {
    state.pettyaccounts = pettyaccounts;
  },
  STORE_PETTYACCOUNT_UPDATE(state, accounttypeId) {
    let Pettyaccount = state.pettyaccounts.find(function(pettyaccount) {
      return pettyaccount.id === accounttypeId;
    });
    state.systemPettyaccount = Pettyaccount;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/pettyaccounts/mutations.js